<template>
  <Head title="ロード・オブ・ザ・ウォール">
    <meta name="description" content="ロード・オブ・ザ・ウォール">
  </Head>

  <BreezeGuestLayout>
    <!-- loading -->
    <div id="loading">
      <div class="spinner">
        <img src="/images/top/icon-slime.gif">
        <img src="/images/top/loading.png">
      </div>
    </div>

    <section class="top-kv">
      <div class="top-kv-wall">
        <img src="/images/top/main-wall.png"/>
      </div>
      <div class="top-kv_title">
        <Logo class="header_logo_img" width="163.5" height="28.5" alt="ロード・オブ・ザ・ウォール" />
      </div>
      <div class="top-kv_version">
        version beta
      </div>
      <div class="top-kv-register">
        <Link class="nav-link" :href="route('register')">
          いますぐはじめる
          <img src="/images/top/icon-triangle.svg" class="top-kv-register-triangle" />
        </Link>
      </div>
      <div class="top-kv-tree">
        <img src="/images/top/main-tree.png"/>
      </div>
      <div class="top-kv-cavelier" @click="horseRun()" v-bind:class="{'running': isRunning}">
        <img v-if="!isRunning" src="/images/top/main-cavelier-idle.gif"/>
        <img v-else src="/images/top/main-cavelier-run.gif"/>
      </div>
      <div class="top-kv-ground"></div>
      <img src="/images/top/main-cavelier-run.gif" style="display:none;" />
    </section>

    <section class="top-kv-border"></section>

    <section class="top-about">
      <h2 class="top-about_heading">
        <img src="/images/top/headline01.svg" alt="「ロード・オブ・ザ・ウォール」とは">
      </h2>
      <div class="top-about_wrap">
        <p class="top-about_wrap_text">
          「ロード・オブ・ザ・ウォール」は実際のクライミングジムで課題をクリアすることにより、敵を倒し、自らの分身であるキャラクターのレベルを上げていくゲームです。<br>
          キャラクターのレベルが上がることにより、キャラクターが進化し、見た目も変わっていきます。
        </p>
        <figure class="top-about_wrap_figure">
          <img src="/images/top/fig01.png">
        </figure>
      </div>
    </section>

    <section class="top-how2">
      <h2 class="top-how2_heading">
        <img src="/images/top/headline02.svg" alt="あそびかた">
      </h2>
      <div class="top-how2_wrap">

        <div class="top-how2_wrap_block">
          <h3 class="top-how2_wrap_block_heading">
            クライミングジムで課題をクリアする
          </h3>
          <p class="top-how2_wrap_block_lead">
            「ロード・オブ・ザ・ウォール」に参加しているクライミングジムで課題をクリアします。
          </p>
          <figure class="top-how2_wrap_block_figure">
            <img src="/images/top/fig-how01.jpg">
          </figure>
        </div>

        <div class="top-how2_wrap_block">
          <h3 class="top-how2_wrap_block_heading">
            記録をつける
          </h3>
          <p class="top-how2_wrap_block_lead">
            「ロード・オブ・ザ・ウォール」でクリアした課題にチェックを入れ、記録します。
          </p>
          <figure class="top-how2_wrap_block_figure">
            <img src="/images/top/fig-how02.jpg">
          </figure>
        </div>

        <div class="top-how2_wrap_block">
          <h3 class="top-how2_wrap_block_heading">
            経験値がたまり、キャラがレベルアップする
          </h3>
          <p class="top-how2_wrap_block_lead">
            課題をクリアすればするほど、経験値がたまっていき、キャラのレベルが上がります。
          </p>
          <figure class="top-how2_wrap_block_figure">
            <img src="/images/top/fig-how03.jpg">
          </figure>
        </div>

      </div>
    </section>

    <section class="top-gyms">
      <h2 class="top-gyms_heading">
        <img src="/images/top/headline03.svg" alt="クライミングジム">
      </h2>
      <p class="top-gyms_lead">
        ロード・オブ・ザ・ウォールに参加しているクライミングジム
      </p>
      <div class="top-gyms_wrap">
        <!-- start v-for -->
        <div class="top-gyms_wrap_block" v-for="gym in gyms" :key="gym.id">
          <Link :href="`/gyms/${gym.slug}`">
            <figure class="top-gyms_wrap_block_fig">
              <img :src="gym.image" class="top-gyms_wrap_block_fig_img">
            </figure>
            <h3 class="top-gyms_wrap_block_title">
              {{ gym.title }}
            </h3>
          </Link>
        </div>
        <!-- end v-for -->
      </div>

      <Side />
    </section>
  </BreezeGuestLayout>
</template>

<script>
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import { Head, Link, onMounted } from '@inertiajs/inertia-vue3';
import Logo from '@/Shared/Logo'
import Side from '@/Shared/Side'

export default {
  components: {
    BreezeGuestLayout,
    Head,
    Link,
    Logo,
    Side
  },
  data() {
    return {
      isRunning: false
    }
  },
  props: {
    gyms: Array
  },
  methods: {
    horseRun() {
      this.isRunning = true;
    },
    destroy(id) {
      if (confirm('本当に削除しますか？')) {
        this.$inertia.delete(route("gyms.destroy", id));
      }
    },
  },
  mounted() {
    // alert("ページが読み込まれました");

    let img = document.createElement('img');
    img.src = '/images/top/main-cavelier-run.gif';

    // window.onload = () => {
      // alert("ページが読み込まれました");
    // };

    // window.onload = function() {
      const spinner = document.getElementById('loading');
      spinner.classList.add('loaded');
    // }
  }
}
</script>
